module.exports = __webpack_public_path__ + "static/media/Login_background.2b09da0f.jpg";